import BaseStore from './baseStore'
import api from '../api/api'

const baseUrl = '/comments/'

export const namespaced = true
const basestore = new BaseStore(baseUrl)

const getDefaultState = () => {
  return {
    ...structuredClone(basestore.state),
    show: false,
    currentTab: {},
    commentLoading: false,
    commentObject: null
  }
}

export const state = getDefaultState()

export const mutations = {
  ...basestore.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  TOGGLE_SHOW(state, bool = null) {
    bool === null ? (state.show = !state.show) : (state.show = bool)
  },
  SET_CURRENT_TAB(state, currentTab) {
    state.currentTab = currentTab
  },
  TOGGLE_COMMENT_LOADING(state, bool = null) {
    state.commentLoading = bool === null ? !state.commentLoading : bool
  },
  SET_COMMENT_OBJECT(state, currentObjectId) {
    state.commentObject = currentObjectId
  },
  SET_PARAMETER(state, { value, item, parameter }) {
    item[parameter] = value
  }
}

export const actions = {
  ...basestore.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },

  async fetchItems(context) {
    context.commit('TOGGLE_COMMENT_LOADING', true)
    const projectId = await context.rootGetters['project/selectedProjectId']
    if (projectId) {
      let contentType = state.currentTab ? state.currentTab.model : 'project'
      const searchParams = new URLSearchParams({
        project_id: projectId,
        content_type: contentType
      }).toString()
      let url = baseUrl + `?${searchParams}`
      let response = await api.get(url)
      let comments = response['data']

      context.commit('SET_ITEMS', comments)
    }
    context.commit('TOGGLE_COMMENT_LOADING', false)
  },
  toggleShow({ commit }, bool = null) {
    commit('TOGGLE_SHOW', bool)
  },
  toggleCommentLoading({ commit }, bool = null) {
    commit('TOGGLE_COMMENT_LOADING', bool)
  },
  async setCurrentTab(context, item) {
    if (item) {
      await context.commit('SET_CURRENT_TAB', item)
      await context.dispatch('fetchItems')
    } else {
      await context.commit('SET_CURRENT_TAB', {})
      await context.commit('RESET_STATE')
    }
  },
  // Needs to be updated the date modified
  async updateComment(context, payload) {
    context.commit('TOGGLE_WRITE_LOADING')
    let url = baseUrl + payload.id + '/'
    const response = await api.patch(url, payload)
    context.commit('REPLACE_ITEM', response.data)
    context.commit('TOGGLE_WRITE_LOADING')
  },
  setCommentObject({ commit }, payload) {
    commit('SET_COMMENT_OBJECT', payload)
  }
}

export const getters = {}
